
<div class="header-toolbar">
  <h1>
    Vérifier un registre des mouvements
  </h1>
</div>

<form #form="ngForm" (ngSubmit)="submit()" autocomplete="off">

  <!-- Toolbar -->
  <div class="main btn-toolbar">
        
    <div class="btn-group" *ngIf="entity">    
      <div class="content">
        
        <a class="btn" href="/files/shares-ledger/entity/{{ entity.id }}/{{ entity.version }}">
          <t-icon name="file_download"></t-icon>
          <span class="text">Télécharger</span>
        </a>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="panel">
    <h2>Vérification</h2>

    <div class="form-group">
      <label for="signature">Signature</label>
      <input #signatureInput id="signature" type="text" placeholder="Veuillez saisir la signature du document" [formControl]="signature" maxlength="1000"/>

    </div>
    
    <p style="padding: 16px;">
      <button class="btn btn-primary" type="submit" [disabled]="!valid">
        <t-icon name="check"></t-icon>
        <span class="text">Vérifier</span>
      </button>
    </p>

    <div class="empty-table compact" *ngIf="mode === 'searching'">
      <p>Vérification...</p>
    </div>

    <div class="empty-table compact" *ngIf="mode === 'form' && entity === null">
      <p>la signature saisie n'est pas valide</p>
    </div>

  </div>

  <div class="grid" *ngIf="entity">

    <div class="column">
      
      <sl-entity-infos [entity]="entity"></sl-entity-infos>

    </div>
    
    <div class="column">
      
      <sl-entity-blockchain [entity]="entity"></sl-entity-blockchain>
  
      <sl-entity-details [entity]="entity"></sl-entity-details>
    </div>

  </div>

  <ng-container *ngIf="entity">
    <div class="form-group">
      <t-checkbox label="Afficher les lignes masquées" [(checked)]="showHidden"></t-checkbox>
    </div>
  
    <sl-entity-movements-ledger [entity]="entity" [showHidden]="showHidden"></sl-entity-movements-ledger>
  </ng-container>
  
</form>